import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { catchError, retry, map, filter } from 'rxjs/operators';
import { UtenteElement } from '../components/back-office/ricerca-utente-detail/ricerca-utente-detail.component';
import { ReturnErrorModel, ErrorsModel } from './front-office.service';
import { URLSearchParams } from 'url';



export interface DefendoDRuolo {
  id: number;
  descrizione: string;
}
export interface DefendoDIstitutoGaranzia {
  id: number;
  descrizione: string;
  ruoliIstituto: DefendoDRuolo[];
}
export interface UtenteElementPaginated extends UtenteElement {
  page: number;
  size: number;
  idIstituto? : number;
  idRuolo? : number;
}
export interface Organico {
  id: number;
  codiceFiscale: string;
  cognome: string;
  nome: string;
  identita: string;
  email: string;
  telefono: string;
  istituti: DefendoDIstitutoGaranzia[];
}
export class OrganicoSemplice {
  codiceFiscale: string;
  cognome: string;
  nome: string;
  identita: string;
  email: string;
  telefono: string;
  id? : number;
  constructor(utenteElement: UtenteElement) {
    this.codiceFiscale = utenteElement.codiceFiscale;
    this.cognome = utenteElement.cognome || null;
    this.nome = utenteElement.nome || null;
    this.identita = utenteElement.userName || null;
    this.email = utenteElement.email || null;
    this.telefono = utenteElement.telefono || null;
    this.id = utenteElement.id;
  }

}

export class PageFilterOrganicoSemplice extends OrganicoSemplice {
  idIstituto? : number;
  idRuolo? : number;
  page?: number;
  size?: number;
  constructor(utenteElementPaginated: UtenteElementPaginated) {
    super(utenteElementPaginated)
    this.page = utenteElementPaginated.page || 0;
    this.size = utenteElementPaginated.size || 10;
    this.idIstituto = utenteElementPaginated.idIstituto || null;
    this.idRuolo = utenteElementPaginated.idRuolo || null;
  }

}

// @Injectable({
//   providedIn: 'root'
// })

@Injectable()
export class OrganicoInterrogatorService {

  constructor(private http: HttpClient) { }

  getUtenti(filtri: any) {
    // const headers = new Headers();
    // headers.append('Content-Type', 'application/json');
    let newFilter = new PageFilterOrganicoSemplice(filtri);
    // let params = new URLSearchParams();
    Object.keys(newFilter).forEach(x => {
      if (newFilter[x] == null || newFilter[x]==='') {
        delete newFilter[x];
      }
    });

    return this.http.get(`backoffice/utenti/all`, { params: newFilter as any }) as Observable<any>;
  }

  getDettaglioUtente(idUtente: number) {
    //if(!idUtente) return of({});
    return this.http.get(`backoffice/utenti/${idUtente}/detail`);
  }

  getListaIstituti() {
    return this.http.get('backoffice/istitutoGaranzia/all') as Observable<Array<{ id: number, descrizione: string }>>;
  }

  getListaRuoli() {
    return this.http.get('backoffice/ruolo/all') as Observable<Array<{ id: number, descrizione: string }>>;
  }

  findRichiedenti(rich: any) {
    const filterRich = new PageFilterOrganicoSemplice(rich);
    // let params = new URLSearchParams();
    Object.keys(filterRich).forEach(x => {
      if (filterRich[x] == null || filterRich[x] === '')
        delete filterRich[x];
    });
    return this.http.get('backoffice/utenti/richiedenti/filter', { params: filterRich as any }) as Observable<any>;
  }

  findIntestatari(intes: any) {
    const filterIntes = new PageFilterOrganicoSemplice(intes);
    // let params = new URLSearchParams();
    Object.keys(filterIntes).forEach(x => {
      if (filterIntes[x] == null || filterIntes[x] === '')
        delete filterIntes[x];
    });
    return this.http.get('backoffice/utenti/intestatari/filter', { params: filterIntes as any }) as Observable<any>;
  }

  postNuovoUtente(value: any) {
    // throw new Error("Method not implemented.");
 //   console.log(value);
    // const ut: OrganicoSemplice = { nome: value.nome, cognome: value.cognome, codiceFiscale: value.codice_fiscale, identita: value.username, email: value.email, telefono: value.telefono };
    return this.http.post(`backoffice/utenti/new`, value)
      .pipe(
        catchError(this.handleError<Array<{ id: number, nome: string }>>('post data', []))
      );


  }

  postDeleteUtente(idOrganico:number) {
    return this.http.post(`backoffice/utenti/${idOrganico}/delete`, {idOrganico:idOrganico});
  }

  postDettaglioUtente(ut: Organico) {
  //  console.log(ut);
    let headers = new HttpHeaders();
    let formDataOBject = {};
    //const postData: PraticaModel = {};// ut

    // const dataToSend = this.jsonToFormData(ut);
    // Object.keys(formDataOBject).forEach(key => {
    //   if (formDataOBject[key]) {
    //     dataToSend.append('richiedentiFiles', formDataOBject[key], key.toString());
    //   }
    // });

    headers.append('Content-Type', 'application/form-data');

    //return this.http.post(`/utenti/update`, dataToSend, { headers })
    return this.http.post(`backoffice/utenti/update`, ut, { headers })
      .pipe(
        catchError(this.handleError<Array<{ id: number, nome: string }>>('post data', []))
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<ReturnErrorModel> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
      if(error && error.status && error.status === 403) {
        return of( { error : true, status : 403, generali : []});
      }
      // Let the app keep running by returning an empty result.
      let generalErrors: ErrorsModel[] = [];
      if (typeof (error.error) != "string") Object.keys(error.error).forEach(key => {
        let errorObj: ErrorsModel = { message: null, order: null, key: null };
        errorObj.message = error.error[key];

        errorObj.key = key;
        generalErrors.push(errorObj);

      });
      const returnObject: ReturnErrorModel = {
        error: true,
        generali: generalErrors
      };
      return of(returnObject);
    };
  }


  private buildFormData(formData, data, parentKey ? ) {
    if (data && Array.isArray(data) && !(data instanceof Date) && !(data instanceof File)) {
      Object.keys(data).forEach(key => {
        this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
      });
    }
    else if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
      Object.keys(data).forEach(key => {
        this.buildFormData(formData, data[key], parentKey ? `${parentKey}.${key}` : key);
      });
    } else {
      const value = data == null ? '' : data;

      if (value !== null) formData.append(parentKey, value);
    }
  }

  private jsonToFormData(data) {
    const formData = new FormData();

    this.buildFormData(formData, data);

    return formData;
  }
}
